import { Button, ButtonProps } from "antd";
import * as React from "react";

type RenderButtonActionProps = {
  icon?: React.ReactNode;
  title?: string;
  disabled?: boolean;
  isLoading?: boolean;
  onClick?: ButtonProps["onClick"];
};

export const RenderButtonAction: React.FC<RenderButtonActionProps> = ({
  icon,
  title,
  disabled,
  isLoading,
  onClick,
}) => (
  <Button
    size="small"
    type="text"
    icon={icon}
    title={title}
    disabled={disabled}
    loading={isLoading}
    onClick={(event) => {
      event.stopPropagation();
      onClick?.(event);
    }}
  />
);
